import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo accedo al contenido después de comprar?',
    a: 'Inmediatamente después de confirmar tu pago recibís un email con el link de descarga del ebook y todos los bonos. El acceso es instantáneo, las 24 horas del día.'
  }, {
    q: '¿Qué formas de pago aceptan?',
    a: 'Pagás de forma segura a través de MERCADO PAGO, la plataforma de pagos más confiable de Latinoamérica. Aceptamos todas las tarjetas de crédito (Visa, Mastercard, American Express, Naranja, Cabal y más), tarjetas de débito, transferencia bancaria y dinero en cuenta de Mercado Pago. Tu compra está 100% protegida.'
  }, {
    q: '¿Necesito experiencia previa en temas de salud o nutrición?',
    a: 'No. El Protocolo Digestivo de 72 Horas™ está diseñado para ser comprensible sin ningún conocimiento técnico previo. Cada concepto se explica de forma clara y cada paso es concreto y aplicable desde el primer día.'
  }, {
    q: '¿Funciona si también tengo gastritis o hernia hiatal?',
    a: 'El protocolo aborda los factores digestivos que generalmente están presentes en reflujo, gastritis y hernia hiatal. Sin embargo, si tenés un diagnóstico médico activo, siempre es importante que cualquier cambio lo hagas con el conocimiento de tu médico.'
  }, {
    q: '¿Cuánto tiempo tengo acceso al material?',
    a: 'El acceso es permanente. Una vez que descargás el ebook y los bonos, son tuyos para siempre. Podés consultarlos en cualquier momento, desde cualquier dispositivo.'
  }, {
    q: '¿Hay soporte disponible si tengo dudas?',
    a: 'Sí. Podés escribirnos por email ante cualquier consulta sobre el contenido o el acceso. Respondemos dentro de las 24 a 48 horas hábiles.'
  }, {
    q: '¿Cuánto tiempo lleva aplicar el protocolo?',
    a: 'El protocolo está diseñado para aplicarse en 72 horas con ajustes simples. No requiere horas de dedicación diaria — son cambios prácticos que se integran a tu rutina sin interrumpirla.'
  }, {
    q: '¿Necesito dejar de tomar mis medicamentos para aplicar el protocolo?',
    a: 'No. El Protocolo Digestivo de 72 Horas™ es complementario y no reemplaza ningún tratamiento médico. Si estás medicado, consultá con tu médico antes de hacer cualquier cambio en tu medicación.'
  }, {
    q: '¿Hay actualizaciones del material?',
    a: 'Si el contenido se actualiza, los compradores actuales reciben la nueva versión sin costo adicional. Tu inversión incluye todas las versiones futuras del protocolo.'
  }, {
    q: '¿Cómo funciona la garantía de 7 días?',
    a: 'Si dentro de los 7 días de tu compra no estás conforme con el contenido o no notás ningún resultado aplicando el protocolo, te devolvemos el 100% de tu inversión. Solo necesitás escribirnos al email de soporte. Sin burocracia, sin preguntas complicadas.'
  }];
  return <section id="faq" className="bg-blanco py-[100px]" data-id="element-133">
      <div className="container-custom" data-id="element-134">
        <SectionHeader eyebrow="Preguntas frecuentes" title={<>
              Todo lo que necesitás
              <br data-id="element-136" />
              saber antes de acceder
            </>} theme="light" data-id="element-135" />

        <div className="mt-[60px] border-t border-black/10" data-id="element-137">
          {faqs.map((faq, idx) => {
          const isActive = openIndex === idx;
          return <div key={idx} className="border-b border-black/10" data-id="element-138">
                <button onClick={() => setOpenIndex(isActive ? null : idx)} className={`w-full text-left py-6 flex items-center justify-between gap-5 text-[17px] md:text-[16px] font-medium transition-colors duration-200 ${isActive ? 'text-verde-oscuro' : 'text-negro hover:text-verde'}`} data-id="element-139">
                  {faq.q}
                  <div className={`shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-[18px] transition-all duration-300 ${isActive ? 'bg-verde text-white rotate-45' : 'bg-crema text-verde font-light'}`} data-id="element-140">
                    +
                  </div>
                </button>
                <AnimatePresence data-id="element-141">
                  {isActive && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-142">
                      <div className="pb-6 text-[16px] text-gris leading-[1.8]" data-id="element-143">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}